export const PREDICATE_STATUS_COLORS = Object.freeze({
  met: '#9ef7c5',
  not_met: '#ff7a7a',
  unevaluated: '#ffe082',
});

function safeArray(value) {
  return Array.isArray(value) ? value : [];
}

function toNumber(value, fallback = null) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

function shortenValue(value) {
  if (value == null || value === '') return '—';
  if (typeof value === 'number') {
    if (Math.abs(value) >= 1) return String(Number(value.toFixed(6)));
    return String(Number(value.toPrecision(4)));
  }
  return String(value);
}

export function formatPredicateText(predicate) {
  const p = predicate || {};
  switch (p.kind) {
    case 'price_gte':
      return `Price >= ${shortenValue(toNumber(p.value, 0))}`;
    case 'price_lte':
      return `Price <= ${shortenValue(toNumber(p.value, 0))}`;
    case 'story_type_observed':
      return `${String(p.story_type || 'UNKNOWN')} observed${p.within_minutes ? ` within ${p.within_minutes}m` : ''}`;
    case 'story_type_absent':
      return `${String(p.story_type || 'UNKNOWN')} absent${p.within_minutes ? ` within ${p.within_minutes}m` : ''}`;
    case 'conviction_lte':
      return `Conviction <= ${shortenValue(toNumber(p.value, 0))}`;
    default:
      return String(p.kind || 'Prose-only condition');
  }
}

export function getPredicateSections(thesis) {
  const evaluations = thesis && thesis.predicate_evaluations ? thesis.predicate_evaluations : null;
  const entryItems = evaluations ? safeArray(evaluations.entry) : safeArray(thesis && thesis.entry_predicates);
  const invalidationItems = evaluations ? safeArray(evaluations.invalidation) : safeArray(thesis && thesis.invalidation_predicates);

  const decorate = (item) => {
    const status = item && item.status ? String(item.status) : 'unevaluated';
    const text = formatPredicateText(item);
    return {
      ...item,
      status,
      text,
      dotColor: PREDICATE_STATUS_COLORS[status] || PREDICATE_STATUS_COLORS.unevaluated,
      tooltip: item && item.detail
        ? String(item.detail)
        : item && item.warning
          ? String(item.warning)
          : `${text}${item && item.observed_label ? ` • ${item.observed_label}` : ''}`,
      machine_checkable: Boolean(item && item.machine_checkable),
    };
  };

  const entry = entryItems.map(decorate);
  const invalidation = invalidationItems.map(decorate);
  const all = [...entry, ...invalidation];

  return {
    entry,
    invalidation,
    hasMachineCheckableEntry: entry.some((item) => item.machine_checkable),
    hasMachineCheckableInvalidation: invalidation.some((item) => item.machine_checkable),
    hasUnevaluatedPredicates: all.some((item) => item.status === 'unevaluated'),
  };
}
